import React from 'react';
import Accordion, { AccordionPanelType } from '../common/Accordion';
import RidersAccordionProps from './type';
import { Container } from '../helpers/Grid';
import { Rider } from '../../core/typings/riders';
import { RiderItem } from '../RidersList';
import './styles.scss';

const RidersAccordionContent = ({ riders }: { riders: Rider[] }) => (
  <>
    {riders.map((rider) => <RiderItem {...rider} />)}
  </>
);

const RidersAccordion = ({
  panels,
  statuses,
}: RidersAccordionProps) => {
  const createPanels = () => {
    const items: AccordionPanelType[] = [];
    panels.forEach((panel) => {
      items.push({
        label: panel.label,
        content: (<RidersAccordionContent riders={panel.riders as Rider[]} />),
      });
    });
    return items;
  };

  return (
    <div className="riders-accordion">
      <Container>
        <div className="riders-accordion__inner">
          <Accordion panels={createPanels()} themeColor="white" />
          {statuses && (
            <div className="riders-accordion__statuses">
              <div className="riders-list__sanction-types">
                {statuses.map((status) => (
                  <div className={`sanction sanction--${status.statusCode}`}>
                    {status.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default RidersAccordion;
